import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import * as actions from './redux/actions';
import CommonPageComponent from '../../common/ui/CommonPageComponent';
import { drapcodeIcon } from '../../common/custom/icon-library';
import { checkDatabaseExportPermission } from '../../common/utils/permissions';
import CardTitleHeader from '../../common/ui/CardTitleHeader';
import ExportNav from './ExportNav';
import DbExportForm from './db-dump-export/DbExportForm';
import DbExportList from './db-dump-export/DbExportList';
import { permissionTypes } from 'drapcode-constant';
import CustomLoader from '../common/CustomLoader';

export class DatabaseDumpExport extends Component {
  static propTypes = {
    deploymentSetting: PropTypes.object.isRequired,
    actions: PropTypes.object.isRequired,
  };

  componentDidMount() {
    const { match, actions } = this.props;
    const { projectId, version } = match.params;
    actions.loadPermissionFlags({ projectId });
    actions.loadProjectDepSetting({ projectId, version });
    actions.loadDbExportRequestList({ projectId, version });
  }

  // upgradeAccountEmail = () => {
  //   const { actions, match } = this.props;
  //   const { projectId } = match.params;
  //   actions.requestUpgradeAccount({ projectId, code: permissionTypes.CODE_EXPORT });
  // };

  showDumpExportTable = () => {
    const { actions, deploymentSetting, match } = this.props;
    const { projectId, version } = match.params;
    const { permissionFlags } = deploymentSetting;

    let permissionsArray = [];
    if (permissionFlags && permissionFlags.length > 0) {
      permissionsArray = permissionFlags || [];
    }

    const { DbExportRequestList, saveDbExportRequestPending, loadDbExportRequestListPending } =
      deploymentSetting;

    return (
      <div className="card">
        <div className="card-header card-header-icon" data-background-color="drapcode-violet">
          <i className={`wb ${drapcodeIcon('list')}`}></i>
        </div>
        <div className="card-content">
          <CardTitleHeader title="Dump Export List" />
          <div className="col-md-12 col-lg-12 table-responsive">
            <DbExportList
              projectId={projectId}
              DbExportRequestList={DbExportRequestList}
              deleteDbExportRequest={actions.deleteDbExportRequest}
              saveDbExportRequestPending={saveDbExportRequestPending}
              loadDbExportRequestListPending={loadDbExportRequestListPending}
              deleteFlag={permissionsArray.includes(permissionTypes.CODE_EXPORT)}
            />
          </div>
        </div>
      </div>
    );
  };

  render() {
    const isAllowed = checkDatabaseExportPermission();
    if (!isAllowed) {
      return (
        <CommonPageComponent>
          <PermissionDenied message="Database Dump Export" />
        </CommonPageComponent>
      );
    }

    const { deploymentSetting, match, actions } = this.props;
    const { projectId, version } = match.params;
    const { projectDetail, loadProjectDepSettingPending } = deploymentSetting;
    if (loadProjectDepSettingPending) {
      return <CustomLoader loading={loadProjectDepSettingPending} size="20px" color="#303453" />;
    }

    return (
      <CommonPageComponent>
        <div className="col-md-12 col-lg-12 col-sm-12 col-xs-12 drapcode">
          <ExportNav activeTab={'DATABASE'} version={version} projectId={projectId} />
          <div className="card">
            <div className="card-header card-header-icon" data-background-color="drapcode-violet">
              <i className={`wb ${drapcodeIcon('dbExport')}`}></i>
            </div>
            <div className="card-content">
              <div className="card-title-header">
                <h4 className="card-title">Database Export (Beta)</h4>
                <div className="card-cta"></div>
              </div>
              {projectDetail && (
                <DbExportForm
                  projectDetail={projectDetail}
                  projectId={projectId}
                  saveDbExportRequest={actions.saveDbExportRequest}
                />
              )}
            </div>
          </div>
          {this.showDumpExportTable()}
        </div>
      </CommonPageComponent>
    );
  }
}

function mapStateToProps(state) {
  return {
    deploymentSetting: state.deploymentSetting,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators({ ...actions }, dispatch),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(DatabaseDumpExport);
